import React, { useState } from 'react';
import { useSendMassCommunication } from '../../../hooks/useSale';
import classNames from 'classnames';

export default function SaleComms() {
  const [test, setTest] = useState(true);
  const [confirm, setConfirm] = useState(false);
  const [needsConfirm, setNeedsConfirm] = useState(false);

  const trigger = useSendMassCommunication();

  const send = type => {
    if (test || (!test && confirm)) {
      trigger.mutate({
        type: type,
        test: test
      });
      setTest(true);
      setConfirm(false);
      setNeedsConfirm(false);
    }

    if (!test && !confirm) {
      setNeedsConfirm(true);
    }
  }

  const deny = () => {
    setTest(true);
    setConfirm(false);
    setNeedsConfirm(false);
  }

  const allow = () => {
    setConfirm(true);
    setNeedsConfirm(false);
  }

  return <div>
    <div className="title">Communications</div>

    {trigger.isSuccess && <div className="notification is-success has-text-centered">
      Email Sent
    </div>}

    {needsConfirm && <div className="notification is-danger has-text-centered">
      <p>You are about to send a mass email to all consignors.</p>
      <p>Are you sure you have tested the email and are ready to do this?</p>
      <p className="has-text-weight-semibold">Once started, the process cannot be stopped.  Please double check everything.</p>
      <p className="mt-4">
        <a className="button is-success" onClick={allow}>Yes, do the thing</a> <a className="button is-warning" onClick={deny}>No wait!</a>
      </p>
    </div>}

    <p><input type="checkbox" name="test" checked={test} onChange={() => setTest(!test)} /> Send Test</p>
    <button className={classNames('button is-large', {
      'is-warning': !test && !confirm,
      'is-success': test,
      'is-primary': !test && confirm,
      'has-text-white': !test && confirm
      })} disabled={needsConfirm || trigger.isLoading} onClick={() => send('reminder')}>{(!test && confirm) ? <span>Send New Sale Reminder Now</span> : <span>Send New Sale Reminder</span>}</button>
    <br/>
    <button className={classNames('button is-large mt-2', {
      'is-warning': !test && !confirm,
      'is-success': test,
      'is-primary': !test && confirm,
      'has-text-white': !test && confirm
      })} disabled={needsConfirm || trigger.isLoading} onClick={() => send('first')}>{(!test && confirm) ? <span>Send One Week Reminder Now</span> : <span>Send One Week Reminder</span>}</button>
  </div>
}
